module.exports = __webpack_public_path__ + "img/project1.6fcc91d2.webp";